
import SubscriptionLayout from './SubscriptionLayout';
import SubscriptionPayment from './SubscriptionPayment';

export default function SubscriptionPage() {
    return (
        <SubscriptionLayout>
            <SubscriptionPayment />
        </SubscriptionLayout >
    )
}